import React from 'react'
import PropTypes from 'prop-types'

const PlayIcon = React.memo(({ fill }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="14" viewBox="0 0 10 14">
      <g id="Polygon_3" data-name="Polygon 3" transform="translate(10) rotate(90)" fill={fill}>
        <path d="M 13.03966903686523 9.5 L 0.9603310227394104 9.5 L 7 0.8719014525413513 L 13.03966903686523 9.5 Z" stroke="none"/>
        <path d="M 7 1.743788719177246 L 1.920652389526367 9 L 12.07934761047363 9 L 7 1.743788719177246 M 7 0 L 14 10 L 0 10 L 7 0 Z" stroke="none" fill={fill}/>
      </g>
    </svg>
  )
})

PlayIcon.propTypes = {
  fill: PropTypes.string
}

PlayIcon.defaultProps = {
  fill: "#FFF"
}

export {PlayIcon}